export const fakeReferences = {
    banks: [
        { name: 'ТОЧКА ПАО БАНКА "ФК ОТКРЫТИЕ"', code: '044525999' },
        { name: 'ФИНАНСОВЫЙ Д-Т БАНКА РОССИИ', code: '044536002' },
        { name: 'Д-Т БУХУЧЕТА И ОТЧЕТНОСТИ БАНКА РОССИИ', code: '044537002' },
        { name: 'ПУ БАНКА РОССИИ ПРИГОРОДНОЕ', code: '044594002' },
        { name: 'ПУ БАНКА РОССИИ ЧЕХОВСКОЕ', code: '044674002' },
        { name: 'УФК по Московской области', code: '044697100' },
        { name: 'МУРМАНСКОЕ ОТДЕЛЕНИЕ N8627 ПАО СБЕРБАНК', code: '044705615' },
        { name: 'ПУ БАНКА РОССИИ ПЕЧЕНГСКОЕ', code: '044715002' },
        { name: 'УФК по Мурманской области', code: '044715100' },
        { name: 'УФК по Мурманской области', code: '044780100' },
        { name: 'ОТДЕЛЕНИЕ НОВГОРОД БАНКА РОССИИ', code: '044959001' },
        { name: 'ПАО УКБ "НОВОБАНК"', code: '044959746' },
        { name: 'ФИЛИАЛ ПАО "БАНК УРАЛСИБ" В Г.НОВОСИБИРСК', code: '045004725' },
        { name: 'ФИЛИАЛ "ЦЕНТРАЛЬНЫЙ" ПАО "СОВКОМБАНК"', code: '045004763' },
        { name: '"Хайс" Филиал АО КБ "Модульбанк"', code: '045004864' },
        { name: 'Ф-Л СИБИРСКИЙ ПАО БАНК "ФК ОТКРЫТИЕ"', code: '045004867' },
        { name: 'ОТДЕЛЕНИЕ ОМСК БАНКА РОССИИ', code: '045209001' },
        { name: 'ОМСКОЕ ОТДЕЛЕНИЕ N 8634 ПАО СБЕРБАНК', code: '045209673' },
        { name: 'ОРЕНБУРГСКОЕ ОТДЕЛЕНИЕ N8623 ПАО СБЕРБАНК', code: '045354601' },
        { name: 'ГК "АСВ" - КУ АО "НСТ-БАНК"', code: '045354880' },
        { name: 'КУ БАНК "ЦЕРИХ" (ЗАО)-ГК "АСВ"', code: '045402719' },
        { name: 'ПЕРМСКИЙ Ф-Л ПАО АКБ "МЕТАЛЛИНВЕСТБАНК"', code: '045773712' },
        { name: 'ФИЛИАЛ "ЛЫСЬВА" АО АКБ "АЛЕФ-БАНК"', code: '045773804' },
    ],
    residentStatuses: [
        {
            code: '1',
            name: 'Налогоплательщик является налоговым резидентом Российской Федерации',
        },
        {
            code: '2',
            name: 'Налогоплательщик не является налоговым резидентом Российской Федерации',
        },
        {
            code: '3',
            name: 'Налогоплательщик - высококвалифицированный специалист не является налоговым резидентом Российской Федерации',
        },
        {
            code: '4',
            name: 'Налогоплательщик участник Государственной программы по оказанию содействия добровольному переселению в Российскую Федерацию соотечественников, проживающих за рубежом (член экипажа судна, плавающего под Государственным флагом Российской Федерации), не является налоговым резидентом Российской Федерации',
        },
        {
            code: '5',
            name: 'Налогоплательщик - иностранный гражданин (лицо без гражданства) признан беженцем или получивший временное убежище на территории Российской Федерации, не является налоговым резидентом Российской Федерации',
        },
        {
            code: '6',
            name: 'Налогоплательщик - иностранный гражданин, осуществляет трудовую деятельность по найму в Российской Федерации на основании патента',
        },
    ],
    countries: [
        { code: '004', name: 'Исламская Республика Афганистан' },
        { code: '008', name: 'Республика Албания' },
        { code: '010', name: 'Антарктида' },
        { code: '012', name: 'Алжирская Народная Демократическая Республика' },
        { code: '016', name: 'Американское(Восточное)Самоа' },
        { code: '020', name: 'Княжество Андорра' },
        { code: '024', name: 'Республика Ангола' },
        { code: '028', name: 'Антигуа и Барбуда' },
        { code: '031', name: 'Азербайджанская Республика' },
        { code: '032', name: 'Аргентинская Республика' },
        { code: '036', name: 'Австралия' },
        { code: '040', name: 'Австрийская Республика' },
        { code: '044', name: 'Содружество Багамских островов' },
        { code: '048', name: 'Королевство Бахрейн' },
        { code: '050', name: 'Народная Республика Бангладеш' },
        { code: '051', name: 'Республика Армения' },
        { code: '052', name: 'Барбадос' },
        { code: '056', name: 'Королевство Бельгия' },
        { code: '060', name: 'Бермудские острова' },
        { code: '064', name: 'Королевство Бутан' },
        { code: '068', name: 'Многонациональное Государство Боливия' },
        { code: '070', name: 'Босния и Герцеговина' },
        { code: '072', name: 'Республика Ботсвана' },
        { code: '074', name: 'Остров Буве' },
        { code: '076', name: 'Федеративная Республика Бразилия' },
        { code: '084', name: 'Белиз' },
        { code: '086', name: 'Британская территория в Индийском океане' },
        { code: '090', name: 'Соломоновы острова' },
        { code: '092', name: 'Британские Виргинские острова' },
        { code: '096', name: 'Государство Бруней-Даруссалам' },
        { code: '100', name: 'Республика Болгария' },
        { code: '104', name: 'Союз Мьянма' },
        { code: '108', name: 'Республика Бурунди' },
        { code: '112', name: 'Республика Беларусь' },
        { code: '116', name: 'Королевство Камбоджа' },
        { code: '120', name: 'Республика Камерун' },
        { code: '124', name: 'Канада' },
        { code: '132', name: 'Республика Кабо-Верде' },
        { code: '136', name: 'Острова Кайман' },
        { code: '140', name: 'Центральноафриканская республика' },
        {
            code: '144',
            name: 'Демократическая Социалистическая Республика Шри-Ланка',
        },
        { code: '148', name: 'Республика Чад' },
        { code: '152', name: 'Республика Чили' },
        { code: '156', name: 'Китайская Народная Республика' },
        { code: '158', name: 'Тайвань(Китай)' },
        { code: '162', name: 'Остров Рождества(Австралия)' },
        { code: '166', name: 'Кокосовые(Килинг)острова' },
        { code: '170', name: 'Республика Колумбия' },
        { code: '174', name: 'Союз Коморских Островов' },
        { code: '175', name: 'Майотта' },
        { code: '178', name: 'Республика Конго' },
        { code: '180', name: 'Республика Заир' },
        { code: '184', name: 'Острова Кука' },
        { code: '188', name: 'Республика Коста-Рика' },
        { code: '191', name: 'Республика Хорватия' },
        { code: '192', name: 'Республика Куба' },
        { code: '196', name: 'Республика Кипр' },
        { code: '203', name: 'Чешская Республика' },
        { code: '204', name: 'Республика Бенин' },
        { code: '208', name: 'Королевство Дания' },
        { code: '212', name: 'Содружество Доминики' },
        { code: '214', name: 'Доминиканская Республика' },
        { code: '218', name: 'Республика Эквадор' },
        { code: '222', name: 'Республика Эль-Сальвадор' },
        { code: '226', name: 'Республика Экваториальная Гвинея' },
        { code: '231', name: 'Федеративная Демократическая Республика Эфиопия' },
        { code: '232', name: 'Государство Эритрея' },
        { code: '233', name: 'Эстонская Республика' },
        { code: '234', name: 'Фарерские острова' },
        { code: '238', name: 'Фолклендские острова' },
        { code: '239', name: 'Южная Джорджия и Южные Сандвичевы острова' },
        { code: '242', name: 'Республика Островов Фиджи' },
        { code: '246', name: 'Финляндская Республика' },
        { code: '248', name: 'Эландские острова' },
        { code: '250', name: 'Французская Республика' },
        { code: '254', name: 'Гвиана' },
        { code: '258', name: 'Французская Полинезия' },
        { code: '260', name: 'Французские Южные и Антарктические Территории' },
        { code: '262', name: 'Республика Джибути' },
        { code: '266', name: 'Габонская Республика' },
        { code: '268', name: 'Грузия' },
        { code: '270', name: 'Республика Гамбия' },
        { code: '275', name: 'Государство Палестина' },
        { code: '276', name: 'Федеративная Республика Германия' },
        { code: '288', name: 'Республика Гана' },
        { code: '292', name: 'Гибралтар' },
        { code: '296', name: 'Республика Кирибати' },
        { code: '300', name: 'Греческая Республика' },
        { code: '304', name: 'Гренландия' },
        { code: '308', name: 'Гренада' },
        { code: '312', name: 'Гваделупа' },
        { code: '316', name: 'Территория Гуам' },
        { code: '320', name: 'Республика Гватемала' },
        { code: '324', name: 'Гвинейская Республика' },
        { code: '328', name: 'Кооперативная Республика Гайана' },
        { code: '332', name: 'Республика Гаити' },
        { code: '334', name: 'Остров Херд и Острова Макдональд' },
        { code: '336', name: 'Государство-Город Ватикан' },
        { code: '340', name: 'Республика Гондурас' },
        { code: '344', name: 'Специальный административный район Гонконг' },
        { code: '348', name: 'Венгерская Республика' },
        { code: '352', name: 'Республика Исландия' },
        { code: '356', name: 'Республика Индия' },
        { code: '360', name: 'Республика Индонезия' },
        { code: '364', name: 'Исламская Республика Иран' },
        { code: '368', name: 'Республика Ирак' },
        { code: '372', name: 'Ирландия' },
        { code: '376', name: 'Государство Израиль' },
        { code: '380', name: 'Итальянская Республика' },
        { code: '384', name: "Республика Кот-д'Ивуар" },
        { code: '388', name: 'Ямайка' },
        { code: '392', name: 'Япония' },
        { code: '398', name: 'Республика Казахстан' },
        { code: '400', name: 'Иорданское Хашимитское Королевство' },
        { code: '404', name: 'Республика Кения' },
        { code: '408', name: 'Корейская Народно-Демократическая Республика' },
        { code: '410', name: 'Республика Корея' },
        { code: '414', name: 'Государство Кувейт' },
        { code: '417', name: 'Киргизская Республика' },
        { code: '418', name: 'Лаосская Народно-Демократическая Республика' },
        { code: '422', name: 'Ливанская Республика' },
        { code: '426', name: 'Королевство Лесото' },
        { code: '428', name: 'Латвийская Республика' },
        { code: '430', name: 'Республика Либерия' },
        {
            code: '434',
            name: 'Великая Социалистическая Народная Ливийская Арабская Джамахирия',
        },
        { code: '438', name: 'Княжество Лихтенштейн' },
        { code: '440', name: 'Литовская Республика' },
        { code: '442', name: 'Великое Герцогство Люксембург' },
        { code: '446', name: 'Специальный административный район Макао (Аомынь)' },
        { code: '450', name: 'Республика Мадагаскар' },
        { code: '454', name: 'Республика Малави' },
        { code: '458', name: 'Малайзия' },
        { code: '462', name: 'Мальдивская Республика' },
        { code: '466', name: 'Республика Мали' },
        { code: '470', name: 'Республика Мальта' },
        { code: '474', name: 'Мартиника' },
        { code: '478', name: 'Исламская Республика Мавритания' },
        { code: '480', name: 'Республика Маврикий' },
        { code: '484', name: 'Мексиканские Соединенные Штаты' },
        { code: '492', name: 'Княжество Монако' },
        { code: '496', name: 'Монголия' },
        { code: '498', name: 'Республика Молдова' },
        { code: '499', name: 'Республика Черногория' },
        { code: '500', name: 'Монтсеррат' },
        { code: '504', name: 'Королевство Марокко' },
        { code: '508', name: 'Республика Мозамбик' },
        { code: '512', name: 'Султанат Оман' },
        { code: '516', name: 'Республика Намибия' },
        { code: '520', name: 'Республика Науру' },
        { code: '524', name: 'Федеративная Демократическая Республика Непал' },
        { code: '528', name: 'Королевство Нидерландов' },
        { code: '531', name: 'Кюрасао' },
        { code: '533', name: 'Аруба' },
        { code: '534', name: 'Сен-Мартен (нидерландская часть)' },
        { code: '535', name: 'Бонэйр, Синт-Эстатиус и Саба' },
        { code: '540', name: 'Новая Каледония' },
        { code: '548', name: 'Республика Вануату' },
        { code: '554', name: 'Новая Зеландия' },
        { code: '558', name: 'Республика Никарагуа' },
        { code: '562', name: 'Республика Нигер' },
        { code: '566', name: 'Федеративная Республика Нигерия' },
        { code: '570', name: 'Ниуэ' },
        { code: '574', name: 'Остров Норфолк' },
        { code: '578', name: 'Королевство Норвегии' },
        { code: '580', name: 'Содружество Северных Марианских островов' },
        { code: '581', name: 'Малые Тихоокеанские отдаленные острова США' },
        { code: '583', name: 'Федеративные штаты Микронезии' },
        { code: '584', name: 'Республика Маршалловы Острова' },
        { code: '585', name: 'Республика Палау' },
        { code: '586', name: 'Исламская Республика Пакистан' },
        { code: '591', name: 'Республика Панама' },
        { code: '598', name: 'Независимое Государство Папуа-Новая Гвинея' },
        { code: '600', name: 'Республика Парагвай' },
        { code: '604', name: 'Республика Перу' },
        { code: '608', name: 'Республика Филиппины' },
        { code: '612', name: 'Острова Питкэрн' },
        { code: '616', name: 'Республика Польша' },
        { code: '620', name: 'Португальская Республика' },
        { code: '12000', name: 'Морровинд' },
        { code: '624', name: 'Республика Гвинея-Бисау' },
        { code: '626', name: 'Демократическая Республика Восточный Тимор' },
        { code: '630', name: 'Свободно ассоциированное государство Пуэрто-Рико' },
        { code: '634', name: 'Государство Катар' },
        { code: '638', name: 'Реюньон' },
        { code: '642', name: 'Республика Румыния' },
        { code: '643', name: 'Российская Федерация' },
        { code: '646', name: 'Руандийская Республика' },
        { code: '652', name: 'Сен-Бартелеми' },
        { code: '654', name: 'Остров Святой Елены' },
        { code: '659', name: 'Федерация Сент-Китс и Невис' },
        { code: '660', name: 'Ангилья' },
        { code: '662', name: 'Сент-Люсия' },
        { code: '663', name: 'Сен-Мартен' },
        { code: '666', name: 'Сен-Пьер и Микелон' },
        { code: '670', name: 'Сент-Винсент и Гренадины' },
        { code: '674', name: 'Светлейшая Республика Сан-Марино' },
        { code: '678', name: 'Демократическая Республика Сан-Томе и Принсипи' },
        { code: '682', name: 'Королевство Саудовская Аравия' },
        { code: '686', name: 'Республика Сенегал' },
        { code: '688', name: 'Республика Сербия' },
        { code: '690', name: 'Республика Сейшельские Острова' },
        { code: '694', name: 'Республика Сьерра-Леоне' },
        { code: '702', name: 'Республика Сингапур' },
        { code: '703', name: 'Словацкая Республика' },
        { code: '704', name: 'Социалистическая Республика Вьетнам' },
        { code: '705', name: 'Республика Словения' },
        { code: '706', name: 'Сомалийская Республика' },
        { code: '710', name: 'Южно-Африканская Республика' },
        { code: '716', name: 'Республика Зимбабве' },
        { code: '724', name: 'Королевство Испания' },
        { code: '728', name: 'Республика Южный Судан' },
        { code: '729', name: 'Республика Судан' },
        { code: '732', name: 'Западная Сахара' },
        { code: '740', name: 'Республика Суринам' },
        { code: '744', name: 'Шпицберген и Ян-Майен (Норв.)' },
        { code: '748', name: 'Королевство Свазиленд' },
        { code: '752', name: 'Королевство Швеция' },
        { code: '756', name: 'Швейцарская Конфедерация' },
        { code: '760', name: 'Сирийская Арабская Республика' },
        { code: '762', name: 'Республика Таджикистан' },
        { code: '764', name: 'Королевство Таиланд' },
        { code: '768', name: 'Тоголезская Республика' },
        { code: '772', name: 'Токелау' },
        { code: '776', name: 'Королевство Тонга' },
        { code: '780', name: 'Республика Тринидад и Тобаго' },
        { code: '784', name: 'Объединенные Арабские Эмираты' },
        { code: '788', name: 'Тунисская Республика' },
        { code: '792', name: 'Турецкая Республика' },
        { code: '795', name: 'Туркменистан' },
        { code: '796', name: 'Тёркс и Кайкос' },
        { code: '798', name: 'Тувалу' },
        { code: '800', name: 'Республика Уганда' },
        { code: '804', name: 'Украина' },
        { code: '807', name: 'Республика Македония' },
        { code: '818', name: 'Арабская Республика Египет' },
        {
            code: '826',
            name: 'Соединенное Королевство Великобритании и Северной Ирландии',
        },
        { code: '831', name: 'Гернси' },
        { code: '832', name: 'Джерси' },
        { code: '833', name: 'Остров Мэн' },
        { code: '834', name: 'Объединенная Республика Танзания' },
        { code: '840', name: 'Соединенные Штаты Америки' },
        { code: '850', name: 'Американские Виргинские острова' },
        { code: '854', name: 'Буркина-Фасо' },
        { code: '858', name: 'Восточная Республика Уругвай' },
        { code: '860', name: 'Республика Узбекистан' },
        { code: '862', name: 'Боливарианская Республика Венесуэла' },
        { code: '876', name: 'Уоллис и Футуна' },
        { code: '882', name: 'Независимое Государство Самоа' },
        { code: '887', name: 'Йеменская Республика' },
        { code: '894', name: 'Республика Замбия' },
        { code: '895', name: 'Абхазия' },
        { code: '896', name: 'Южная Осетия' },
        { code: '999', name: 'Лицо без гражданства' },
    ],
    identityDocuments: [
        { code: '21', name: 'Паспорт гражданина Российской Федерации' },
        { code: '03', name: 'Свидетельство о рождении' },
        { code: '07', name: 'Военный билет' },
        {
            code: '08',
            name: 'Временное удостоверение, выданное взамен военного билета',
        },
        { code: '10', name: 'Паспорт иностранного гражданина' },
        {
            code: '11',
            name: 'Свидетельство о рассмотрении ходатайства о признании лица беженцем на территории Российской Федерации по существу',
        },
        { code: '12', name: 'Вид на жительство в Российской Федерации' },
        { code: '13', name: 'Удостоверение беженца' },
        {
            code: '14',
            name: 'Временное удостоверение личности гражданина Российской Федерации',
        },
        {
            code: '15',
            name: 'Разрешение на временное проживание в Российской Федерации',
        },
        {
            code: '18',
            name: 'Свидетельство о предоставлении временного убежища на территории Российской Федерации',
        },
        {
            code: '19',
            name: 'Свидетельство о предоставлении временного убежища на территории Российской Федерации',
        },
        { code: '22', name: 'Загранпаспорт гражданина Российской Федерации' },
        {
            code: '23',
            name: 'Свидетельство о рождении, выданное уполномоченным органом иностранного государства',
        },
        {
            code: '24',
            name: 'Удостоверение личности военнослужащего Российской Федерации',
        },
        { code: '27', name: 'Военный билет офицера запаса' },
        { code: '91', name: 'Иные документы' },
    ],
    driverLicenseCategories: [],
    educationLevels: [],
    languages: [],
    languageSkills: [],
    maritalStatuses: [],
    militaryFitnessCategories: [],
    militaryRankGroups: [],
    militaryRanks: [],
    militarySpecializations: [],
    militaryStatuses: [],
    positionCategories: [],
    positionCategoryGroups: [],
    relationships: [],
    foreignCitizenCategories: [],
};
